/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */

import { TextField } from '@material-ui/core';
import React from 'react';
import { lightStyles } from './useLightStyles';

const InputText = ({
  label,
  required,
  disabled,
  value,
  onChange,
  onBlur,
  helperText,
  errorMessage,
  error,
  name,
  className,
  password,
  testId,
  startAdornment,
  autocomplete,
  endAdornment,
  placeholder,
  maxLength,
}) => {
  const [inputValue, setInputValue] = React.useState(value);

  const handleOnChange = (event) => {
    const newValue = event.target.value;
    setInputValue(newValue);
    if (onChange) {
      onChange(event);
    }
  };

  const classes = lightStyles();

  return (
    <TextField
      className={`${className || classes.root}`}
      data-testid={testId}
      name={name}
      value={onChange ? value : inputValue}
      placeholder={placeholder}
      label={label}
      required={required}
      disabled={disabled}
      error={!!error}
      type={password ? 'password' : 'text'}
      helperText={error ? errorMessage : helperText}
      onChange={handleOnChange}
      onBlur={onBlur}
      autoComplete={autocomplete}
      InputLabelProps={{
        classes: {
          root: classes.label,
          disabled: classes.disabled,
        },
      }}
      FormHelperTextProps={{
        className: classes.helperText,
      }}
      inputProps={{
        maxLength,
      }}
      InputProps={{
        startAdornment,
        endAdornment,
        className: classes.input,
        classes: {
          input:
            label && label.length > 0
              ? classes.inputWithLabel
              : classes.inputBase,
          focused: classes.inputFocus,
          disabled: classes.disabled,
          root: classes.input,
          error: classes.error,
        },
      }}
      variant="filled"
    />
  );
};

InputText.defaultProps = {
  required: false,
  disabled: false,
  error: false,
  testId: 'input',
  className: '',
  label: '',
  helperText: undefined,
  name: undefined,
  errorMessage: undefined,
  endAdornment: null,
  startAdornment: null,
  placeholder: '',
  autocomplete: undefined,
};

export default InputText;
